import { render, staticRenderFns } from "./ChannelsList.vue?vue&type=template&id=32808e6b&scoped=true&"
import script from "./ChannelsList.vue?vue&type=script&lang=js&"
export * from "./ChannelsList.vue?vue&type=script&lang=js&"
import style0 from "./ChannelsList.scss?vue&type=style&index=0&id=32808e6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32808e6b",
  null
  
)

export default component.exports